import type { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { AppMarkdownParser } from "../../../../../shared/components/AppMarkdownParser";
import { AGREEMENT } from "../../constants";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  onClose: () => void;
  handleOk: () => void;
}

export const AgreementModalPresentation = (props: Props) => {
  const { t } = useTranslation();
  const { onClose, handleOk, ...rest } = props;
  return (
    <ModalBasic
      title={t("login.modal_agreement_title")}
      onOk={() => {
        props.handleOk();
        props.onClose();
      }}
      closeModal={onClose}
      onClose={onClose}
      onCancel={onClose}
      hasFooter
      hasCloseButton
      buttonOkText={t("login.confirm_button")}
      footerClassName={styles["agreement-footer"]}
      {...rest}
    >
      <div className={styles.body}>
        <AppMarkdownParser content={AGREEMENT} />
      </div>
    </ModalBasic>
  );
};
